import Vue from 'vue';

Vue.filter('eligibleCCIDsFormat', (ccidList, type) => {
  if (!type) {
    const ccidFilterList = ccidList.filter((ccidData) => (!ccidData.is_full || ccidData.is_create));
    return ccidFilterList;
  }
  return ccidList;
});
